const TENANT = process.env.REACT_APP_TENANT || "ooru";

const configs = {
  ooru: {
    id: "ooru",
    appName: "CredIssuer",
    pageTitle: "CredIssuer",
    credentialIdPrefix: "credissuer:",
    referenceIdLabel: "Reference ID on CredIssuer",
    defaultLanguage: "en",
    supportedLanguages: ["en", "pt"],
    publicDualDocumentPreview: false,
  },
  stp: {
    id: "stp",
    appName: "GovVerify STP",
    pageTitle: "GovVerificaSTP",
    credentialIdPrefix: "credissuer:",
    referenceIdLabel: "Reference ID",
    defaultLanguage: "pt",
    supportedLanguages: ["en", "pt"],
    publicDualDocumentPreview: true,
    documentTitles: {
      pt: "GovVerificaSTP | Verifique Credenciais Digitais",
      en: "GovVerificaSTP | Verify Digital Credentials",
    },
  },
};

export const currentTenant = TENANT;
export const appConfig = configs[TENANT] || configs.ooru;
